module.exports = __webpack_public_path__ + "static/quaals_feather_token_bird-9f3e286d35774bf065f05b86552c2814.jpeg";